/* eslint-disable react/no-unused-prop-types */
import { Fragment } from 'react';
import { CarouselArrowsType } from 'redux/schemas/models/mentor-request';
import CarouselArrow from './carousel-arrow';

type CarouselControlsProps = CarouselArrowsType;

const CarouselControls = (props: CarouselControlsProps) => (
  <Fragment>
    {(['left', 'right']).map((direction: 'left' | 'right') => (
      <Fragment key={direction}>
        {props[direction].show && (
          <CarouselArrow
            direction={direction}
            onClick={props[direction].onClick}
          />
        )}
      </Fragment>
    ))}
  </Fragment>
);

export default CarouselControls;
